import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textOption', 'textField', 'attachmentOption', 'attachmentField'];

  connect() {
    this.checkDisplayField();
  }

  checkDisplayField() {
    if (this.textOptionTarget.checked) {
      this.textFieldTarget.classList.remove('hidden');
      this.attachmentFieldTarget.classList.add('hidden');
    } else if (this.attachmentOptionTarget.checked) {
      this.textFieldTarget.classList.add('hidden');
      this.attachmentFieldTarget.classList.remove('hidden');
    } else {
      this.textFieldTarget.classList.add('hidden');
      this.attachmentFieldTarget.classList.add('hidden');
    }
  }
}
